module.exports = __webpack_public_path__ + "img/chrome.c1c7be71.svg";